var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          {
            staticClass: "row",
            staticStyle: { display: "flex", flex: "1 1 auto" },
          },
          [
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("div", { staticClass: "img-square-wrapper" }, [
                _c("img", {
                  class:
                    "card-img img-fluid m-05 product-image-" + _vm.product.id,
                  attrs: {
                    src:
                      _vm.product.media.length > 0
                        ? _vm.product.media[0].url
                        : "images/cover.png",
                  },
                }),
                _vm._v(" "),
                _vm.product.media.length > 1
                  ? _c(
                      "span",
                      _vm._l(_vm.product.media, function (media) {
                        return _c("span", { staticClass: "ml-05 mb-2" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.changeImage(
                                    _vm.product.id,
                                    media.url
                                  )
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "rounded",
                                attrs: {
                                  src: media.thumbnail,
                                  height: "50",
                                  width: "50",
                                },
                              }),
                            ]
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6 pl-05 " }, [
              _c("div", { staticClass: "card-body p-1" }, [
                _c("h1", {
                  staticClass: "font-large-1",
                  domProps: { textContent: _vm._s(_vm.product.title) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _vm.product.average_rating !== null
                    ? _c("span", [
                        _c("span", {
                          class:
                            "rating-static rating-" +
                            _vm.product.average_rating * 10,
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-sm btn-outline-warning product-rating",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showRatings()
                          },
                        },
                      },
                      [
                        _vm.product.ratings.length === 0
                          ? _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.__("product.form.buttons.add_rating")
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.ratings.length === 1
                          ? _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.__("product.form.buttons.view_rating")
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-text p-1 breakAll" }, [
                _c("span", {
                  staticClass: "breakAll image-resize",
                  domProps: {
                    innerHTML: _vm._s(_vm.product.product_description),
                  },
                }),
              ]),
              _vm._v(" "),
              _vm.product.group !== null || _vm.product.supplier !== null
                ? _c("div", { staticClass: "pl-1 pr-1 pt-05 pb-05" }, [
                    _vm.product.group !== null
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "/member/group/" + _vm.product.group.slug,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card text-white mb-0 border-0",
                                },
                                [
                                  _c("img", {
                                    staticClass: "card-img img-fluid",
                                    staticStyle: { height: "3rem" },
                                    attrs: {
                                      src:
                                        _vm.product.group.group_cover == null
                                          ? "/images/cover.jpg"
                                          : _vm.product.group.group_cover.url,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "text-white mb-0",
                                          staticStyle: {
                                            "line-height": "1rem",
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.__("globals.posted_in")
                                              ) + " "
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.product.group.title)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn-sm btn-outline-white ml-auto",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.__("globals.view_group")
                                            ) + " "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "feather icon-chevron-right",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.product.supplier !== null
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/member/supplier/" +
                                  _vm.product.supplier.slug,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card text-white mb-0 border-0",
                                },
                                [
                                  _c("img", {
                                    staticClass: "card-img img-fluid",
                                    staticStyle: { height: "3rem" },
                                    attrs: {
                                      src:
                                        _vm.product.supplier
                                          .supplier_cover_image == null
                                          ? "/images/cover.jpg"
                                          : _vm.product.supplier
                                              .supplier_cover_image.url,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "text-white mb-0",
                                          staticStyle: {
                                            "line-height": "1rem",
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.__("globals.posted_in")
                                              ) + " "
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(_vm.product.supplier.title)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn-sm btn-outline-white ml-auto",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.__("globals.view_page")
                                            ) + " "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "feather icon-chevron-right",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.disabled === 1
                ? _c("div", { staticClass: "p-1" }, [
                    _c("div", { staticClass: "card bg-outline-gray" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _c("h4", { staticClass: "card-title danger" }, [
                          _vm._v(
                            _vm._s(
                              _vm.__("globals.disabled_product_box_header")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _vm._v(
                          _vm._s(_vm.__("globals.disabled_product_box_content"))
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex pr-05 p-1 align-items-center justify-content-between border-top border-bottom mr-05",
                },
                [
                  _vm.product.price !== null
                    ? _c("div", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.__("globals.form.paragraph.your_price")
                            ) +
                              " " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.product.price,
                                  _vm.site_tax
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user.confirmed === true
                    ? _c("div", { staticClass: "d-flex" }, [
                        _vm.product.external_link !== null
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.product.external_link,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary waves-effect waves-light",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.__(
                                              "product.form.buttons.view_product_site"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "feather icon-chevron-right",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _c("div", [
                              _vm.product.price === null &&
                              this.lowest_plan_price !== null
                                ? _c("div", [
                                    _c("strong", [
                                      _c("span", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-dark",
                                            staticStyle: {
                                              "text-decoration": "underline",
                                            },
                                            attrs: { href: "/member/plans" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.__("globals.upgrade"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.__("globals.to_get_it_for")
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                this.lowest_plan_price,
                                                _vm.site_tax
                                              )
                                            ) +
                                            " " +
                                            _vm._s(_vm.__("globals.on_a")) +
                                            "\n                                        " +
                                            _vm._s(this.lowest_plan_name) +
                                            " " +
                                            _vm._s(_vm.__("globals.plan")) +
                                            "\n                                    "
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.product.price !== null
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "/member/product/" +
                                            _vm.product.slug +
                                            "/add_to_cart",
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary waves-effect waves-light",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.__("globals.buy_now")
                                                ) +
                                                " "
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-tag",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between pl-1 pr-1",
                },
                [
                  _c("newsfeed-owner-info", {
                    attrs: {
                      user_data: _vm.product.owner,
                      supplier_data: null,
                      shared: false,
                      type: "product",
                      time: null,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-danger",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.report.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.__("globals.report")) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "d-flex justify-content-between mt-1 mb-0 border-top",
          },
          [
            _c(
              "div",
              { staticClass: "font-small-3 text-bold-700" },
              [
                _c("likes", {
                  attrs: {
                    id: this.product.slug,
                    "likes-count": this.product.likesCount,
                    "is-liked": this.product.isLiked,
                    "liked-by-users": this.product.userLikes,
                    type: "product",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "font-small-3 text-bold-700" }, [
              _c(
                "a",
                {
                  staticClass: "p-05 d-block",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.commentsShow = !_vm.commentsShow
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-comment-o" }),
                  _vm._v(" "),
                  _vm.commentsCount === 1
                    ? _c("span", [
                        _c("span", {
                          domProps: { textContent: _vm._s(_vm.commentsCount) },
                        }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comment"))),
                      ])
                    : _c("span", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.commentsCount === 0 ? " " : _vm.commentsCount
                            ),
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comments"))),
                      ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "font-small-3 text-bold-700" },
              [
                _c("social-share", {
                  attrs: {
                    id: this.product.id,
                    social: this.product.socialShare,
                  },
                  on: { shareModal: _vm.triggerShareModal },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.commentsShow
        ? _c(
            "div",
            [
              _c("comments", {
                attrs: {
                  newsfeed_uuid: this.product.newsfeed_uuid,
                  id: this.product.slug,
                  type: "product",
                },
                on: { length: _vm.updateCommentsCount },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.share_newsfeed
        ? _c(
            "div",
            [
              _c("share-modal", {
                attrs: {
                  original_newsfeed_id: this.product.newsfeed_id,
                  module: this.product,
                  type: "product",
                },
                on: {
                  closeModal: function ($event) {
                    _vm.share_newsfeed = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ratings", {
        attrs: {
          data: _vm.product,
          module: "product",
          slug: _vm.product.slug,
          count: _vm.product.ratings.length,
          enableRating: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }